import React, { useEffect, useState } from "react";
import { formatDate } from "@ismael1361/utils";

interface CountdownProps {
	date?: Date; // Data alvo (futuro)
	duration?: number; // Duração em segundos
	format?: string;
	onComplete?: () => void;
	className?: string;
}

const getDateBy = (date?: Date, duration?: number) => {
	if (date instanceof Date) {
		return date;
	} else {
		return new Date(Date.now() + (duration ?? 0) * 1000);
	}
	return new Date();
};

export const Countdown: React.FC<CountdownProps> = ({ date, duration, format = "YYYY/MM/DD hh:mm:ss", onComplete, className }) => {
	const [toDate, setToDate] = useState<Date>(getDateBy(date, duration));

	useEffect(() => {
		setToDate(getDateBy(date, duration));
	}, [date, duration]);

	const calculateTimeLeft = () => {
		const difference = +toDate - +new Date();
		return Math.max(0, Math.floor(difference / 1000));
	};

	const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

	useEffect(() => {
		const timer = setInterval(() => {
			const newTimeLeft = calculateTimeLeft();
			setTimeLeft(newTimeLeft);

			if (newTimeLeft <= 0) {
				clearInterval(timer);
				if (onComplete) {
					onComplete();
				}
			}
		}, 1000);

		return () => clearInterval(timer);
	}, [toDate, onComplete]);

	// Cria uma data arbitrária com os segundos restantes para usar o formater
	const displayDate = new Date(0, 0, 0, 0, 0, timeLeft);

	return <span className={className}>{formatDate(displayDate, "mm:ss")}</span>;
};
